import {IResponse, requestWithToken} from "./RequestBase";
import {config} from "../config";
import {actions as restReceiver,} from "../store/sliceWebsocket";
import {store} from "../store/configureStore";
import {IReceiver} from "../store/sliceWebsocket";


export const fetchReceiverPower = async (): Promise<IResponse> => {
    const url = `${config.homeUrl}/api/receiver/receiver/power`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
        },
        false,
        false
    );
    writeToStore(data);
    return data;
}

export const fetchReceiverMute = async (): Promise<IResponse> => {
    const url = `${config.homeUrl}/api/receiver/receiver/mute`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
        },
        false,
        false
    );
    writeToStore(data);
    return data;
}

export const fetchReceiverStatus = async (): Promise<IResponse> => {
    const url = `${config.homeUrl}/api/receiver/receiver/status`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
        },
        false,
        false
    );
    writeToStore(data);
    return data;
}

export const fetchReceiverMode = async (body: any): Promise<IResponse> => {
    const url = `${config.homeUrl}/api/receiver/receiver/mode`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        },
        false,
        false
    );
    writeToStore(data);
    return data;
}

export const fetchReceiverVolume = async (body: any): Promise<IResponse> => {
    const url = `${config.homeUrl}/api/receiver/receiver/volume`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        },
        false,
        false
    );
    writeToStore(data);
    return data;
}

export const fetchReceiverFreq = async (body: string): Promise<IResponse> => {
    const url = `${config.homeUrl}/api/receiver/receiver/freq`
    const data: IResponse = await requestWithToken(url,
        {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: body
        },
        false,
        false
    );
    writeToStore(data);
    return data;
}

const writeToStore = (data: IResponse) => {
    if (data?.status === 200) {
        const receiver: IReceiver = data.data;
        store.dispatch(restReceiver.setReceiverRest(receiver))
    }
}
